<template>
  <div class="overflow-hidden rounded-xl bg-black shadow-lg ring-1 ring-black/5">
    <iframe
      ref="iframeRef"
      class="aspect-video w-full"
      :src="materialUrl"
      title="Lecture video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue';
import Player from '@vimeo/player';

defineProps<{ materialUrl: string }>();
const emit = defineEmits<{ ended: [] }>();

const iframeRef = ref<HTMLIFrameElement | null>(null);
let player: Player | null = null;

onMounted(() => {
  if (!iframeRef.value) return;
  player = new Player(iframeRef.value);
  player.on('ended', () => emit('ended'));
});

onBeforeUnmount(() => {
  player?.destroy();
  player = null;
});
</script>
